import { useState, useEffect } from "react";
import * as Mui from "@mui/material";
import { Cancel, CheckCircle } from "@mui/icons-material";
import { CategoriesSelect } from "components";
import {
  useGetCategoriesQuery,
  useSetArticleCategoryMutation,
} from "redux/api/slices/server";

const SetArticleModal = (props) => {
  const { onClose, open, selectedItem, ...other } = props;
  const categories = useGetCategoriesQuery();
  const [ustKategori, setUstKategori] = useState(selectedItem.categoryId);
  const [setArticleCategory, reqData] = useSetArticleCategoryMutation();
  const [urunKategori, setUrunKategori] = useState(0);

  const handleOnChange = (e) => {
    setUrunKategori(e.target.value);
  };

  const handleCancel = () => {
    onClose();
    setUrunKategori(0)
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (ustKategori !== 0) {
      setArticleCategory({
        articleId: selectedItem?.id,
        categoryId: ustKategori,
      });
    }
  };

  useEffect(() => {
    setUstKategori(selectedItem.categoryId);
  }, [selectedItem]);

  if (reqData.isLoading) {
    return <Mui.Skeleton height={200} />;
  }

  return (
    <Mui.Dialog
      sx={{ "& .MuiDialog-paper": { width: "100%" } }}
      maxWidth="md"
      open={open}
      {...other}
    >
      <Mui.DialogTitle>{selectedItem?.title} Makalesi</Mui.DialogTitle>
      <Mui.Box
        component="form"
        noValidate
        onSubmit={handleSubmit}
        sx={{ mt: 1 }}
      >
        <Mui.DialogContent dividers>
          <Mui.Alert severity="warning" sx={{ mb: 2 }}>
            <Mui.AlertTitle>Dikkat</Mui.AlertTitle>
            Bu bölümde {selectedItem?.title} Makalesi Seçtiğiniz Kategorideki{" "}
            <strong>Tüm Ürünlere</strong> Eklenecektir
          </Mui.Alert>
          {reqData.isSuccess && (
            <Mui.Alert severity="success" sx={{ mb: 2 }}>
              <strong>
                {selectedItem?.title} Makalesi {selectedItem?.category} Adlı
                Kategoriye Ait Tüm Ürünlere Eklendi
              </strong>
            </Mui.Alert>
          )}
          {reqData.isError && (
            <Mui.Alert severity="error" sx={{ mb: 4 }}>
              <strong>Bir Hata Ouştu</strong>
            </Mui.Alert>
          )}
          <Mui.FormControl fullWidth sx={{ mb: 4 }}>
            {categories.isLoading ? (
              <Mui.Skeleton height={45} />
            ) : (
              <CategoriesSelect
                data={categories}
                urunKategori={urunKategori}
                handleOnChange={handleOnChange}
              />
            )}
          </Mui.FormControl>
        </Mui.DialogContent>
        <Mui.DialogActions>
          <Mui.Button
            sx={{ mr: 1 }}
            startIcon={<Cancel />}
            variant="contained"
            size="small"
            color="error"
            autoFocus
            onClick={handleCancel}
          >
            Kapat
          </Mui.Button>
          <Mui.Button
            endIcon={<CheckCircle />}
            variant="contained"
            size="small"
            color="success"
            type="submit"
          >
            Kaydet
          </Mui.Button>
        </Mui.DialogActions>
      </Mui.Box>
    </Mui.Dialog>
  );
};

export default SetArticleModal;
